import {
  CURRENCIES,
} from 'utils/constants';

export const getCurrencySettings = (_currency) => {
  const currencyValues = CURRENCIES.find(({ value }) => value === _currency);
  let symbol;
  let groupSeparator;
  let decimalSeparator;

  if (currencyValues.symbol) {
    symbol = currencyValues.symbol;
  } else {
    symbol = '$';
  }

  if (currencyValues.group_sep) {
    groupSeparator = currencyValues.group_sep;
  } else {
    groupSeparator = ',';
  }

  if (currencyValues.decimal_sep) {
    decimalSeparator = currencyValues.decimal_sep;
  } else {
    decimalSeparator = '.';
  };

  return { symbol, groupSeparator, decimalSeparator };
};
